import {
  IndexTable,
  Badge,
  InlineStack,
  Box,
  Icon,
  Button,
  Checkbox,
  Thumbnail,
  Tooltip,
  Popover,
  Select,
  ActionList,
  Banner,
  Spinner,
} from "@shopify/polaris";
import {
  ChevronDownIcon,
  NoteIcon,
  PersonIcon,
  MenuHorizontalIcon,
  QuestionCircleIcon,
  ChevronUpIcon
} from "@shopify/polaris-icons";
import React, { Fragment, useState, useMemo, useEffect } from "react";
import CustomerInformationModal from "../modal/CustomerInformationModal";
import OrderPackageModal from "../modal/OrderPackageModal";
import ShippingMethodsModal from "../modal/ShippingMethodsModal";
import BadgeTag from "../common/BadgeTag";
import _, { forEach } from "lodash";
import PaymentCheckModal from "../modal/PaymentCheckModal";
import ArchiveOrderModal from "../modal/ArchiveOrderModal";
import BulkSourcingModal from "../modal/BulkSourcingModal";
import SymbolTake from "../../../../components/SymbolTake";
import OrderTrackingModal from "../modal/OrderTrackingModal";
import RefundTipsModal from "../modal/RefundTipsModal";
import OrderInvoiceModal from "../modal/OrderInvoiceModal";
import BulkPaymentModal from "../modal/BulkPaymentModal";
import WalletForOrderModal from "../modal/WalletForOrderModal";
import PayForOrderModal from "../modal/PayForOrderModal";
import DlocalPayTipModal from "../modal/DlocalPayTipModal";
import PayoneerBalancesConnect from "../../../../components/PayoneerBalancesConnect";
import PayoneerBalancesOrderSelect from "../../../../components/PayoneerBalancesOrderSelect";
import PayoneerBalancesOrderConfirm from "../../../../components/PayoneerBalancesOrderConfirm";
import PayoneerBalancesAgain from "../../../../components/PayoneerBalancesAgain";
import InitNotPageContent from "../common/InitNotPageContent";
import CommonTableSkeletonItem from "../common/CommonTableSkeletonItem";
import InitPageContent from "../common/InitPageContent";
import "./index.css";
import {
  reqGetNewGuideOrder,
  reqGetOrderBatchSourcingReason,
  reqGetOrderNewPaymentProcess,
  reqGetOrderNewPaypalCheckout,
  reqGetOrderNewShopifyDetailSelect,
  reqGetOrderNewShopifyDot,
  reqPostOrderNewPaymentWallet,
} from "../../../../api";
import NotSourcingCompleteModal from "../modal/NotSourcingCompleteModal";
import SourcingOrderTipModal from "../modal/SourcingOrderTipModal";
import OrderInventoryModal from "../modal/OrderInventoryModal";
import ShopifyModal from "../../../../components/ShopifyModal";
import { useSelector } from "react-redux";
const OrderTable = ({
  selected,
  listData,
  setListData,
  selectableOrders,
  selectedResources,
  allResourcesSelected,
  handleSelectionChange,
  getPageData,
  requestParams,
  setSearchLoading,
  loading,
  toastFun,
  handleStoreTabChange,
  newcomeGuidance,
  setNewcomeGuidance,
  newcomeStep,
  setNewcomeStep,
  isGuideRef,
  collapsibleItem,
  setCollapsibleItem
}) => {
  const binding_sale = useSelector(
    (state) => state.languageReducer.subScriptData.binding_sale
  );
  // 总条数
  const pageMsg = () => {
    let total = listData.count ? listData.count : 0;
    const { page, size } = requestParams;
    const startNum = total > 0 ? (page - 1) * size + 1 : 0;
    const endNum = page * size > total ? total : page * size;
    let text = (
      <div>
        Showing {startNum} - {endNum} of {total} results
        <div className="per_page_footer">
          , at most{" "}
          <div className="per_page_select">
            {" "}
            <Select
              options={[
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
              ]}
              onChange={(value) => {
                const calculatedTotalPages = Math.ceil(total / Number(value));
                if (page > calculatedTotalPages) {
                  // 如果当前页码超出范围，重置为第一页
                  getPageData({ size: Number(value), page: 1 });
                } else {
                  getPageData({ size: Number(value) });
                }
                setSearchLoading(true);
              }}
              value={requestParams.size}
            />
          </div>
          per page
        </div>
      </div>
    );
    return text;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  // 是否存在上一页
  const hasPrevious = useMemo(() => {
    const { page, size } = requestParams;
    let total = listData.count ? listData.count : 0;

    const maxPageNum = _.ceil(total / size);
    if (page > 1 && page <= maxPageNum) {
      return loading ? false : true;
    } else if (page === 1) {
      return false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData, requestParams, loading]);

  // 是否存在下一页
  const hasNext = useMemo(() => {
    const { page, size } = requestParams;
    let total = listData.count ? listData.count : 0;
    const maxPageNum = _.ceil(total / size);
    if (_.inRange(page, 1, maxPageNum)) {
      return loading ? false : true;
    } else if (page === maxPageNum) {
      return false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData, requestParams, loading]);

  // 上一页
  const handlePrev = () => {
    getPageData({ page: Number(requestParams.page) - 1 });
    setSearchLoading(true);
    handleSelectionChange("page", false, 0);
    if (document) {
      if (document?.documentElement || document?.body) {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      }
    }
  };
  // 下一页
  const handleNext = () => {
    getPageData({ page: Number(requestParams.page) + 1 });
    setSearchLoading(true);
    handleSelectionChange("page", false, 0);
    if (document) {
      if (document?.documentElement || document?.body) {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      }
    }
  };
  // 礼品包装
  const [isShowPackingOrderModal, setisShowPackingOrderModal] = useState({
    open: false,
    data: {},
  }); //订单包装显示
  // 物流方式弹窗
  const [shippingMethodsData, setShippingMethodsData] = useState({
    open: false,
  });
  // 地址
  const [addressData, setAddressData] = useState({
    open: false,
  });
  // 查询物流追踪记录
  const [trackingData, setTrackingData] = useState({
    open: false,
    id: "",
    data: {},
  });
  // 退款
  const [orderRefundData, setOrderRefundData] = useState({
    open: false,
    id: "",
    data: {},
  });
  // 开票
  const [invoicesData, setInvoicesData] = useState({
    open: false,
    id: "",
    data: {},
  });

  // 归档/解档
  const [archiveOrderData, setArchiveOrderData] = useState({
    open: false,
    applyLoading: false,
    archive: true,
    ids: [],
    split_order_list:[]
  });

  // 批量source
  const [bulkSourceData, setBulkSourceData] = useState({
    open: false,
    applyLoading: false,
    isBulk: true,
    sourcingTip: false,
    ids: [],
  });
  const [shopifyOrderRefundModalData, setShopifyOrderRefundModalData] =
    useState({
      shopifyOrderRefundModal: false, //shopify已退款订单批量支付提醒
      shopifyRefundOrderData: {}, //shopify退款订单数据
    });
  // 子项操作功能
  

  const [paymentData, setPaymentData] = useState({
    toPayOrderId: "",
    toPayOrderName: "",
    toPayOrderType: 0, // 订单类型：1 shopify 2 礼品包装 3 产品批发
    toPayActive: false,
    createPayPalOrderId: 0,
    toPayCouponId: 0,
    isPoints: false, //是否使用积分
    toPayCouponMoney: 0,
    isBatchToPay: false, //批量付款
    batchPayOrderIds: [],
    handleWalletActiveLoading: false, //钱包确定支付按钮
    toCheckoutLoading: false, //钱包支付加载状态
    payLogId: 0, // 执行支付记录ID
    operationNumber: 0,
    currentExecutionsNumber: 0,
    noFreeShippingTipsActive: false, //不包邮订单提示物流选择
    noFreeShippingOrder: "",
    // 提示订单地址异常不能付款
    addressFailedModal: false,
    addressFailedOrder: "",
    setOrderStatusIds: [], // 更改订单地址异常状态
    addressFailedLoading: false,
    isShowBulkPaymentModal: false, //批量支付弹窗
    totalPrice: 0, //价格钱包支付计算产品总价
    totalShippingCost: 0, //运费钱包支付计算产品总价
    isNotSourcing: false, //订单sku未sourcing完成弹窗
    user_cpf: "", //巴西税号
    is_br: 0,
  });

  const handleBulkPayment = (id) => {
    // 创建 Set 用于快速查找
    const idSet = new Set(id);
    // 过滤出 id 在 Set 中的对象
    const result = listData?.list
      .filter((item) => idSet.has(item.id))
      .map((item) => item.dsm_record);
    let data = listData?.list;

    let ids = [];
    let name = [];

    // (type=1) shopify订单，不包邮的需要提示选择物流方式
    let isPass = true;
    let noFreeShippingOrderName = [];
    let allAddressTrue = true;
    let orderAddressFailedNames = [];

    //金额
    var totalPrice = 0;
    let totalShippingCost = 0;
    // let itemsCount = 0;
    let notSourcing = false;
    let batchSourcing = [];
    for (let i = 0; i < data.length; i++) {
      if (result.includes(data[i].dsm_record)) {
        if (
          data[i].dsm_payment_status === "Unpaid" ||
          data[i].dsm_payment_status === "Partially paid"
        ) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_name);
          totalPrice +=
            Number(data[i].product_cost) + parseFloat(data[i].ioss_vat);

          // 如果存在未sourcing完成sku的则提示弹窗
          if (
            data[i].sourcing_status !== "" ||
            data[i].dsm_item_count !== data[i].shopify_item_count
          ) {
            notSourcing = true;
          }

          // 订单地址检测
          if (data[i].address_failed === 1) {
            allAddressTrue = false;
            orderAddressFailedNames.push(data[i].dsm_order_name);
          }

          // (shopify订单 type=1 \ 自定义订单 type=4) 不是包邮，且没有运费，需要提示选择物流方式
          let shippingCost = 0;
          // let details = orderPageData.list;
          // for (let j = 0; j < details.length; j++) {
          let itemShippingCost = parseFloat(data[i].shipping_cost);
          if (itemShippingCost > 0) {
            shippingCost += itemShippingCost;
          } else {
            handleOrderShippingTips(true, data[i].dsm_order_name);
            return;
          }
          // }

          if (shippingCost <= 0) {
            isPass = false;
            noFreeShippingOrderName.push(data[i].dsm_order_name);
          }
          // 统计订单的运费
          totalShippingCost += shippingCost;
        }
      }
      if (id.includes(data[i].id)) {
        if (data[i].sourcing_status !== "") {
          batchSourcing.push(data[i].id);
        }
      }
    }
    totalPrice += totalShippingCost;
    setPaymentData((prevValue) => ({
      ...prevValue,
      isBatchToPay: true,
      user_cpf: listData.user_cpf,
      is_br: listData.is_br,
      batchPayOrderIds: ids,
    }));
    // 数据检测
    if (!isPass) {
      handleOrderShippingTips(true, noFreeShippingOrderName.join(","));
      return;
    }
    // 判断选择的订单地址异常情况
    if (!allAddressTrue) {
      handleAddressFailedTips(true, ids, orderAddressFailedNames.join(","));
      return;
    }

    if (ids.length > 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        isBatchToPay: true,
        user_cpf: listData.user_cpf,
        is_br: listData.is_br,
        batchPayOrderIds: ids,
      }));
      let flag = false;
      let shopifyRefundStatus = "";
      for (let i = 0; i < data.length; i++) {
        if (ids.includes(data[i].dsm_record)) {
          if (
            data[i].shopify_financial_status === "refunded" ||
            data[i].shopify_financial_status === "partially_refunded" ||
            data[i].shopify_financial_status === "voided"
          ) {
            shopifyRefundStatus = data[i].shopify_financial_status;
            flag = true;
          }
        }
      }
      if (flag) {
        setPaymentData((prevValue) => ({
          ...prevValue,
          isBatchToPay: true,
          batchPayOrderIds: ids,
        }));
        setShopifyOrderRefundModalData((prevValue) => ({
          ...prevValue,
          shopifyOrderRefundModal: true,
          shopifyRefundOrderData: {
            shopifyRefundStatus,
            name,
            PaymentType: 0,
            totalPrice,
            totalShippingCost,
          },
        }));
      } else {
        if (notSourcing) {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isNotSourcing: true,
            totalPrice,
            totalShippingCost,
          }));
        } else {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isShowBulkPaymentModal: true,
            totalPrice,
            totalShippingCost,
          }));
        }
      }
    } else {
      console.log(batchSourcing, id);

      if (batchSourcing.length === id.length) {
        toastFun("Sourcing in Progress");
      } else {
        toastFun("No payable orders");
      }
    }
  };

  const handleWalletActive = async (PaymentType) => {
    // 谷歌分析函数
    // this.handleTrackGoogleManager('Dropshipman pay order', {
    //   domain: utils.getStore('S_SHOP_DOMAIN') || window.S_SHOP_DOMAIN,
    //   value: this.state.totalPriceWallet,
    //   currency: 'USD',
    // })

    //判断钱包的钱是否够用
    if (
      listData?.wallet_money <
      paymentData.totalPriceWallet - paymentData.toPayCouponMoney
    ) {
      toastFun("Insufficient balance");
    } else {
      setPaymentData((prevValue) => ({
        ...prevValue,
        handleWalletActiveLoading: true,
      }));
      let ids = paymentData.batchPayOrderIds;
      let params = {
        ids,
        b: 0,
        coupon_id: paymentData.toPayCouponId,
        is_point: paymentData.isPoints ? 1 : 0,
      };

      const response = await reqPostOrderNewPaymentWallet(params);
      setPaymentData((prevValue) => ({
        ...prevValue,
        toWalletActive: false,
        toPayCouponId: 0,
        isPoints: false,
        toPayCouponMoney: 0,
      }));

      if (response.code === "200") {
        setPaymentData((prevValue) => ({
          ...prevValue,
          handleWalletActiveLoading: false,
        }));
        toastFun("Payment processing");
        getPageData();

        // 启动定时器查询支付状态
        if (response.data) {
          setPaymentData((prevValue) => ({
            ...prevValue,
            payLogId: response.data.pay_id,
          }));
          var importTimer = setInterval(() => {
            GetPaymentProcess(response.data.pay_id).then(function (response) {
              if (response === 200) {
                clearInterval(importTimer);
              }
            });
          }, 3000);
        }
      } else {
        toastFun(response.msg);
        setPaymentData((prevValue) => ({
          ...prevValue,
          handleWalletActiveLoading: false,
        }));
      }
      // 创建PayPal订单有误，关闭弹窗
      handlePayForOrderModal(0, 0, "", 0, false, PaymentType);
    }
  };
  // 查询支付的状态
  const GetPaymentProcess = async (id) => {
    const params = { id };
    const response = await reqGetOrderNewPaymentProcess(params);
    if (response.code === "200") {
      let getData = response.data;
      setPaymentData((prevValue) => ({
        ...prevValue,
        operationNumber: getData.job === 0 ? getData.total : 0,
        currentExecutionsNumber: getData.job === 0 ? getData.success : 0,
      }));

      if (getData.job === 1) {
        // 结束
        setTimeout(() => {
          // 刷新列表
          getPageData();
        }, 1000);

        return 200;
      }
      return 201;
    } else {
      setPaymentData((prevValue) => ({
        ...prevValue,
        payLogId: 0,
        operationNumber: 0,
        currentExecutionsNumber: 0,
      }));

      return 200;
    }
  };
  // [PayPal] Checkout 弹窗 PaymentType 支付类型 1:PayPal 2:钱包
  const handlePayForOrderModal = (
    recordKey,
    id,
    name,
    type,
    bool,
    PaymentType,
    totalPrice = 0,
    shippingCosts = 0,
    CouponId = 0,
    CouponMoney = 0,
    isPoints
  ) => {
   
    setShopifyOrderRefundModalData((prevValue) => ({
      ...prevValue,
      shopifyOrderRefundModal: false,
    }));
    setPaymentData((prevValue) => ({
      ...prevValue,
      handleWalletActiveLoading: false,
      toCheckoutLoading: false,
    }));

    switch (PaymentType) {
      case 1:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: id,
          toPayOrderName: name,
          toPayOrderType: type,
          batchPayOrderIds: id,
          toPayActive: bool,
          createPayPalOrderId: 0,
          toPayCouponId: CouponId,
          isPoints,
          toPayCouponMoney: CouponMoney,
        }));
        if (bool) {
          handleCheckoutOrder(PaymentType, {
            isBatchToPay: paymentData.isBatchToPay,
            batchPayOrderIds: id,
            toPayOrderId: id,
            toPayCouponId: CouponId,
            isPoints,
          });
        } else {
          // 如果是批量下单
          if (paymentData.isBatchToPay) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              isBatchToPay: false,
              batchPayOrderIds: [],
            }));
          }
        }
        break;
      case 2:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: id,
          toPayOrderName: name,
          toPayOrderType: type,
          toWalletActive: bool, //打开钱包提示弹窗
          totalPriceWallet: parseFloat(Number(totalPrice).toFixed(2)), //钱包支付订单金额
          createPayPalOrderId: 0,
          toPayCouponId: CouponId,
          isPoints,
          toPayCouponMoney: CouponMoney,
        }));
        if (bool) {
        } else {
          // 如果是批量下单
          if (paymentData.isBatchToPay) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              isBatchToPay: false,
              batchPayOrderIds: [],
            }));
          }
        }
        break;
      case 3:
        break;
      default:
        break;
    }
  };

  // checkout order
  const handleCheckoutOrder = async (PaymentType, data) => {
    let ids = data.batchPayOrderIds;
    // if (data.isBatchToPay) {
    //   // 批量
    //   ids = data.batchPayOrderIds;
    // } else {
    //   ids = data.toPayOrderId;
    // }
    setPaymentData((prevValue) => ({
      ...prevValue,
      toCheckoutLoading: true,
    }));
    let params = {
      ids,
      // b: data.isBatchToPay ? 1 : 0,
      coupon_id: data.toPayCouponId,
      is_point: data.isPoints ? 1 : 0,
    };

    const response = await reqGetOrderNewPaypalCheckout(params);
    setPaymentData((prevValue) => ({
      ...prevValue,
      toCheckoutLoading: false,
    }));
    if (response.code === "200") {
      // toggleToast(response.msg, false);

      setPaymentData((prevValue) => ({
        ...prevValue,
        createPayPalOrderId: response.data.id,
      }));
    } else {
      toastFun("Fail to activate");
      handlePayForOrderModal(0, 0, "", 0, false, PaymentType);
    }
  };
  // 订单地址异常状态转换为待支付操作
  // 继续付款
  const handleAddressFailedOrderToUnpaid = () => {
    let data = listData?.list;

    let ids = [];
    let name = [];

    //金额
    var totalPrice = 0;
    let totalShippingCost = 0;
    // let itemsCount = 0;
    for (let i = 0; i < data.length; i++) {
      if (paymentData.batchPayOrderIds.includes(data[i].dsm_record)) {
        if (
          data[i].dsm_payment_status === "Unpaid" ||
          data[i].dsm_payment_status === "Partially paid"
        ) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_name);
          totalPrice +=
            Number(data[i].product_cost) + parseFloat(data[i].ioss_vat);

          // (shopify订单 type=1 \ 自定义订单 type=4) 不是包邮，且没有运费，需要提示选择物流方式
          let shippingCost = 0;
          let itemShippingCost = parseFloat(data[i].shipping_cost);
          if (itemShippingCost > 0) {
            shippingCost += itemShippingCost;
          }
          // 统计订单的运费
          totalShippingCost += shippingCost;
        }
      }
    }
    totalPrice += totalShippingCost;

    if (ids.length > 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        isBatchToPay: true,
        addressFailedModal: false,
        batchPayOrderIds: ids,
        isShowBulkPaymentModal: true,
        totalPrice,
        totalShippingCost,
      }));
    }
  };

  // [单个/批量] 订单提示地址异常无法付款
  const handleAddressFailedTips = (bool, ids = [], orderName = "") => {
    if (bool && ids.length === 0) {
      // 处理批量
      let data = listData?.list;
      let name = [];
      for (let i = 0; i < data.length; i++) {
        if (
          paymentData.batchPayOrderIds.includes(data[i].dsm_record) &&
          data[i].address_failed === 1
        ) {
          ids.push(data[i].dsm_record);
          name.push(data[i].dsm_order_name);
        }
      }
      orderName = name.length > 0 ? name.join(",") : "";
    }
    setPaymentData((prevValue) => ({
      ...prevValue,
      addressFailedModal: bool,
      addressFailedOrder: orderName,
      setOrderStatusIds: ids,
    }));
  };
  // 订单提示选择物流方式
  const handleOrderShippingTips = (bool, orderName = "") => {
    setPaymentData((prevValue) => ({
      ...prevValue,
      noFreeShippingTipsActive: bool,
      noFreeShippingOrder: orderName,
    }));
  };

  const [dlocalTip, setDlocalTip] = useState(false);
  const [payoneerConnectOpen, setPayoneerConnectOpen] = useState(false); //payoneer 连接弹窗
  const [payoneerBalances, setPayoneerBalances] = useState({
    data: {},
    open: false,
    ids: [],
    coupon_id: 0,
    isPoints: false,
  });
  // 未授权弹窗 payoneer
  const callPayoneerConnectClosed = () => {
    setPayoneerConnectOpen(false);
  };

  const [payoneerConfirm, setPayoneerConfirm] = useState({
    data: {},
    open: false,
  });
  // 获取确认支付数据
  const handlePayoneerConfirm = (data) => {
    setPayoneerConfirm((prevValue) => ({
      ...prevValue,
      data,
      open: true,
    }));
  };
  //关闭确认支付弹窗
  const handlePayoneerConfirmClose = () => {
    getPageData();
  };

  const [payoneerAgainOpen, setPayoneerAgainOpen] = useState(false); //
  // 刷新数据
  const callPayoneerAgainClosed = () => {
    getPageData();
    setPayoneerAgainOpen(false);
  };
  //单个、批量sourcing
  const handleBatchSourcing = async (ids, bulk) => {
    let canSourcing = [];
    let list = listData?.list;
    for (let i = 0; i < list.length; i++) {
      if (list[i].awaiting_cnt !== 0 && list[i].dsm_paid_at === 0) {
        if (ids.includes(list[i].id)) {
          canSourcing.push(list[i].shopify_record);
        }
      }
    }

    if (canSourcing.length === 0) {
      setBulkSourceData((prev) => ({
        ...prev,
        sourcingTip: true,
        isBulk: bulk,
      }));
      return;
    }
    setBulkSourceData((prev) => ({
      ...prev,
      open: true,
      isBulk: bulk,
      ids: canSourcing,
    }));
  };
  const [sourceFailed, setSourceFailed] = useState(false);
  const [sourceFailedTip, setSourceFailedTip] = useState("");
  const [sourceFailedId, setSourceFailedId] = useState(0);
  const handleFailedTip = async (id) => {
    if (sourceFailedId !== 0) {
      handleCloseFailedTip()
      return;
    }
    try {
      setSourceFailed(true);
      setSourceFailedId(id);
      let res = await reqGetOrderBatchSourcingReason({ id });
      if (res.code === "200") {
        setSourceFailedTip(res.data);
      }
    } catch (error) {}
  };
  const handleCloseFailedTip = ()=>{
      setSourceFailed(false);
      setSourceFailedTip("");
      setSourceFailedId(0);
  }
  // 复选阻断提示
  const [isItemCheck, setIsItemCheck] = useState({
    open: false,
    data: {},
    detail: {},
  });

  // 展开所有子项
  const handleShowItem = (open)=>{
    let list = listData?.list;
    setCollapsibleItem(open)
    if (open) {
      forEach(list, (item) => {
        item.show = 1;
      });
      setListData((prev) => ({
        ...prev,
        list,
      }));
    }else {
      forEach(list, (item) => {
        item.show = 0;
      });
      setListData((prev) => ({
        ...prev,
        list,
      }));
    }
  }

  const resourceName = {
    singular: "order",
    plural: "orders",
  };
  const headingData = [
    { id: "1", title: <Box style={{cursor:'pointer'}} onClick={()=>{
      handleShowItem(!collapsibleItem)
    }}><InlineStack blockAlign="center">
      <span>Order</span>
      <Tooltip content="Expand Order"><span>
      {collapsibleItem ? <Icon
        source={ChevronUpIcon}
        tone="base"
      />:<Icon
      source={ChevronDownIcon}
      tone="base"
    />}
      </span></Tooltip>
    </InlineStack></Box>},
    { id: "2", title: <span>Status</span> },
    { id: "3", title: <span>Date</span> },
    { id: "4", title: <span>Customer</span> },
    { id: "5", title: <span>Package</span> },
    { id: "6", title: <span>Shiping method</span> },
    { id: "7", title: <span>Item</span> },
    { id: "8", title: <span>Total</span> },
    { id: "9", title: <span>Action</span> },
  ];
  const promotedBulkActions =
    (selected === 0 || selected === 3)
      ? [
          {
            content: "Archive orders",
            onAction: () => {
              // 创建 Set 用于快速查找
              const idSet = new Set(selectedResources);
              const split_order_list = listData?.list
                .filter((item) => idSet.has(item.id))
                .filter((item) => item.split_order !== 0);
              // 过滤出 id 在 Set 中的对象
              const result = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.dsm_record);
              const shopifyIds = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.shopify_record);
              setArchiveOrderData((prev) => ({
                ...prev,
                open: true,
                archive: true,
                ids: result,
                sid: shopifyIds,
                split_order_list
              }));
            },
          },
          {
            content: "Bulk sourcing request",
            onAction: () => {
              handleBatchSourcing(selectedResources, true);
            },
          },
          {
            content: "Bulk payment",
            onAction: () => {
              handleBulkPayment(selectedResources);
            },
          },
        ]
      : selected === 1
      ? [
          {
            content: "Archive orders",
            onAction: () => {
              // 创建 Set 用于快速查找
              const idSet = new Set(selectedResources);
              const split_order_list = listData?.list
              .filter((item) => idSet.has(item.id))
              .filter((item) => item.split_order !== 0);
              // 过滤出 id 在 Set 中的对象
              const result = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.dsm_record);
              const shopifyIds = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.shopify_record);
              setArchiveOrderData((prev) => ({
                ...prev,
                open: true,
                archive: true,
                ids: result,
                sid: shopifyIds,
                split_order_list
              }));
            },
          },
          {
            content: "Bulk sourcing request",
            onAction: () => {
              handleBatchSourcing(selectedResources, true);
            },
          },
        ]
      : selected === 2
      ? [
        {
          content: "Archive orders",
          onAction: () => {
            // 创建 Set 用于快速查找
            const idSet = new Set(selectedResources);
            const split_order_list = listData?.list
              .filter((item) => idSet.has(item.id))
              .filter((item) => item.split_order !== 0);
            // 过滤出 id 在 Set 中的对象
            const result = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.dsm_record);
            const shopifyIds = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.shopify_record);
            setArchiveOrderData((prev) => ({
              ...prev,
              open: true,
              archive: true,
              ids: result,
              sid: shopifyIds,
              split_order_list
            }));
          },
        },
        {
          content: "Bulk payment",
          onAction: () => {
            handleBulkPayment(selectedResources);
          },
        },
      ] : selected === 4
      ? [
        {
          content: "Archive orders",
          onAction: () => {
            // 创建 Set 用于快速查找
            const idSet = new Set(selectedResources);
            const split_order_list = listData?.list
              .filter((item) => idSet.has(item.id))
              .filter((item) => item.split_order !== 0);
            // 过滤出 id 在 Set 中的对象
            const result = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.dsm_record);
            const shopifyIds = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.shopify_record);
            setArchiveOrderData((prev) => ({
              ...prev,
              open: true,
              archive: true,
              ids: result,
              sid: shopifyIds,
              split_order_list
            }));
          },
        },
      ] : selected === 5
      ? [
        {
          content: "Archive orders",
          onAction: () => {
            // 创建 Set 用于快速查找
            const idSet = new Set(selectedResources);
            const split_order_list = listData?.list
              .filter((item) => idSet.has(item.id))
              .filter((item) => item.split_order !== 0);
            // 过滤出 id 在 Set 中的对象
            const result = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.dsm_record);
            const shopifyIds = listData?.list
              .filter((item) => idSet.has(item.id))
              .map((item) => item.shopify_record);
            setArchiveOrderData((prev) => ({
              ...prev,
              open: true,
              archive: true,
              ids: result,
              sid: shopifyIds,
              split_order_list
            }));
          },
        },
        {
          content: "Bulk payment",
          onAction: () => {
            handleBulkPayment(selectedResources);
          },
        },
      ] : [
          {
            content: "Unarchive orders",
            onAction: () => {
              // 创建 Set 用于快速查找
              const idSet = new Set(selectedResources);
              // 过滤出 id 在 Set 中的对象
              const split_order_list = listData?.list
              .filter((item) => idSet.has(item.id))
              .filter((item) => item.split_order !== 0);
              const result = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.dsm_record);
              const shopifyIds = listData?.list
                .filter((item) => idSet.has(item.id))
                .map((item) => item.shopify_record);
              setArchiveOrderData((prev) => ({
                ...prev,
                open: true,
                archive: false,
                ids: result,
                sid: shopifyIds,
                split_order_list
              }));
            },
          },
        ];
  const [currentShowDot, setCurrentShowDot] = useState("");
  const handleDotSelect = async (id, dot,shopifyRecord) => {
    try {
      // 创建 Set 用于快速查找
      const idSet = new Set([id]);
      // 过滤出 id 在 Set 中的对象
      const result = listData?.list
        .filter((item) => idSet.has(item.id))
        .map((item) => item.dsm_record);
      const shopifyIds = listData?.list
        .filter((item) => idSet.has(item.id))
        .map((item) => item.shopify_record);
      let params = {
        sids: JSON.stringify(shopifyIds),
        ids: JSON.stringify(result),
        type: dot,
      };
      let res = await reqGetOrderNewShopifyDot(params);
      if (res.code === "200") {
        setListData((prev) => {
          let list = prev.list.map((item) => {
            if (item.shopify_record === shopifyRecord) {
              item.dot_sign = dot;
            }
            return item;
          });
          return { ...prev, list };
        });
        setCurrentShowDot('')
        toastFun("Set Successfully");
      } else {
        toastFun(res.msg);
      }
    } catch (error) {}
  };
  // 颜色标记器
  // 1. 默认展示当前颜色标记
  // 2. 鼠标移上标记器的颜色dot，会有灰色圆角背景
  
  const ColorTag = ({ id, dot,shopifyRecord }) => {
    const [current, setCurrent] = useState(dot);
    const colorList = ["white", "red", "brown", "green", "blue", "grey"];
    let currentDot = current >= 0 ? current : dot;
    return (
      <div
        className={
          currentShowDot === id
            ? "color-group color-group-active"
            : "color-group"
        }
        onClick={(e) => {
          e.stopPropagation();
          if (currentShowDot !== "") {
            setCurrentShowDot("");
          } else {
            setCurrentShowDot(id);
          }
        }}
      >
        <div
          className="color-tag-box"
          onMouseLeave={() => setCurrent(dot)} // 移出容器重置为默认
        >
          {colorList.map((color, index) => (
            <div
              key={index}
              className={`color-tag-box-hover ${
                currentDot === index ? "color-tag-active" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleDotSelect(id, index,shopifyRecord);
              }}
            >
              <div
                className={`color-tag `}
                style={{ backgroundColor: color }}
                onMouseEnter={() => setCurrent(index)}
              ></div>
            </div>
          ))}
        </div>
        <div
          className={`color_current_tag `}
          style={{ backgroundColor: colorList[dot] }}
        />
      </div>
    );
  };

  // 处理点击事件，切换展开状态
  const handleClick = (item, ind) => {
    if (item.show) {
      let newOrders = listData?.list.map((item, index) => {
        if (index === ind) {
          return {
            ...item,
            show: 0,
          };
        }
        return item;
      });
      setListData({
        ...listData,
        list: newOrders,
      });
    } else {
      let newOrders = listData?.list.map((item, index) => {
        if (index === ind) {
          return {
            ...item,
            show: 1,
          };
        } else {
          return {
            ...item,
            show: 0,
          };
        }
      });
      setListData({
        ...listData,
        list: newOrders,
      });
    }
  };
  // 库存扣减
  const [cancelInventory, setCancelInventory] = useState({
    id: "",
    detail_id: "",
    open: false,
    itId: "",
  });
  const handleCancelInventory = (id, detail_id, itId) => {
    setCancelInventory({ id, detail_id, open: true, itId });
  };
  const handleCheckSelectSumit = async (
    dsm_record,
    id,
    is_select,
    order_id,
    skuPop
  ) => {
    try {
      let params = {
        dsm_record: dsm_record,
        detail_id: id,
        sign: is_select ? 1 : 0,
        pop: skuPop ? 0 : 1,
      };
      let res = await reqGetOrderNewShopifyDetailSelect(params);
      if (res.code === "200") {
        setListData((prev) => {
          let list = prev.list.map((it, ind) => {
            if (it.dsm_record === dsm_record) {
              return {
                ...it,
                order_items: it.order_items.map((child, inds) => {
                  if (child.id === id) {
                    child.is_select = is_select ? 1 : 0;
                  }
                  return child;
                }),
              };
            }
            return it;
          });
          return {
            ...prev,
            list,
          };
        });
        setIsItemCheck((prev) => ({
          ...prev,
          open: false,
        }));
        if (is_select) {
          toastFun("Item selected successfully");
        }else {
          toastFun("Item deselected successfully");
        }
        setSearchLoading(true);
        setTimeout(() => {
          getPageData({}, order_id);
        }, 1000);
      } else {
        toastFun("Set Failed");
      }
    } catch (error) {}
  };
  const costQuantityFun = (item, it) => {
    let text = "";
    if (item) {
      text =
        it.paid_quantity > 0 && item.order_scen === 2 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {it.paid_quantity === it.quantity ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ marginRight: 5 }}>
                  {" "}
                  Cost: $0 x {it.paid_quantity} (Inventory Deduction)
                </span>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ marginRight: 5 }}>
                  {" "}
                  Cost1: $0 x {it.paid_quantity} (Inventory Deduction)
                </span>
              </div>
            )}
            {it.paid_quantity === it.quantity ? (
              ""
            ) : (
              <span>
                Cost2: :{" "}
                <SymbolTake
                  price={parseFloat(it.price).toFixed(2)}
                  shopifyPrice={it.dsm === 1 ? false : true}
                />{" "}
                x {Number(it.quantity) - Number(it.paid_quantity)}
              </span>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span>
              Cost:
              <SymbolTake
                price={parseFloat(it.price).toFixed(2)}
                shopifyPrice={it.dsm === 1 ? false : true}
              />{" "}
              x {it.quantity}
            </span>
          </div>
        );
    }
    return text;
  };
  const shopifyQuantityFun = (item, it) => {
    let text = "";
    if (item) {
      text = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span>
            Price: <SymbolTake price={it.shopify_price} shopifyPrice={true} /> x{" "}
            {it.shopify_quantity}
          </span>
        </div>
      );
    }
    return text;
  };
  const ChildrenItem = ({ data, skuPop }) => {
    let detail = data.order_items || [];
    let node = "";
    if (detail.length > 0) {
      node = detail.map((item, index) => (
        <IndexTable.Row
          key={index}
          id={item.id}
          rowType="child"
          disabled={true}
          onClick={() => {}}
        >
          <td className="children_content_item" colSpan={9} onMouseLeave={()=>{
                                  setSourceFailed(false);
                                  setSourceFailedTip("");
                                  setSourceFailedId(0);
                                }}>
            <Box className="children_content_item_box">
              <InlineStack align="space-between" blockAlign="center">
                <Box className="children_content_item_left">
                  <InlineStack blockAlign="center" gap={300}>
                    <Box>
                      {data.dsm_paid_at !== 0 ? (
                        ""
                      ) : (
                        <Checkbox
                          checked={item.is_select}
                          disabled={
                            data.sourcing_status !== "" || item.dsm !== 1
                          }
                          onChange={(value) => {
                            let list = detail.filter(
                              (it) => it.is_select === 1
                            );
                            if (!value && list.length === 1) {
                              toastFun("Keep one item");
                              return;
                            }
                            if (!value && skuPop) {
                              setIsItemCheck((prev) => ({
                                ...prev,
                                open: true,
                                data,
                                detail: item,
                              }));
                            } else {
                              handleCheckSelectSumit(
                                data.dsm_record,
                                item.id,
                                value,
                                data.id,
                                skuPop
                              );
                            }
                          }}
                        />
                      )}
                    </Box>
                    <Box>
                      <Thumbnail
                        source={item.image_url || NoteIcon}
                        size="small"
                        alt="Black choker necklace"
                      />
                    </Box>
                    <Box>
                      <Box
                        className="children_content_item_left_title"
                        title={item.title}
                      >
                        {item.title}
                      </Box>
                      <Box>
                        <InlineStack
                          blockAlign="center"
                          align="flex-start"
                          gap={200}
                        >
                          {item.item_status === "Sourcing Failed" ? (
                            <InlineStack>
                              <BadgeTag content={item.item_status} />
                              <Popover
                                autofocusTarget="container"
                                active={
                                  sourceFailed && sourceFailedId === item.id
                                }
                                onClose={() => {
                                  setSourceFailed(false);
                                  setSourceFailedTip("");
                                  setSourceFailedId(0);
                                }}
                                activator={
                                  <div onClick={() => handleFailedTip(item.id)}>
                                    <Icon
                                      source={QuestionCircleIcon}
                                      backdrop={true}
                                    />
                                  </div>
                                }
                              >
                                <div
                                  style={{
                                    minWidth: "100px",
                                    padding: 10,
                                    minHeight: 40,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {sourceFailedTip === "" ? (
                                    <div style={{ width: "20px" }}>
                                      <Spinner size="size" />
                                    </div>
                                  ) : (
                                    <div>{sourceFailedTip}</div>
                                  )}
                                </div>
                              </Popover>
                            </InlineStack>
                          ) : (
                            <Box>
                              {item.dsm_refund_count > 0 ? (
                                <Tooltip
                                  dismissOnMouseOut
                                  content={
                                    item.quantity > item.dsm_refund_count
                                      ? `Partially Refund : ${item.dsm_refund_count}`
                                      : "Refund"
                                  }
                                >
                                  <Badge tone={"critical"}>
                                    {item.quantity > item.dsm_refund_count
                                      ? `Partially Refund : ${item.dsm_refund_count}`
                                      : "Refund"}
                                  </Badge>
                                </Tooltip>
                              ) : (
                                <BadgeTag content={item.item_status} />
                              )}
                            </Box>
                          )}
                          <Box>SKU: {item.variant_title}</Box>
                          <Box>{shopifyQuantityFun(data, item)}</Box>
                          {item.paid_quantity > 0 ? <Box>
                          Private Storage Inventory: {item.dsm_inventory}
                          </Box>:""}
                          {(item.paid_quantity > 0 && data.order_scen === 2 ) ? <Box>
                          {data.dsm_payment_status === "Partially paid" && (
                            <Button
                              variant="plain"
                              onClick={() =>
                                handleCancelInventory(data.dsm_record, item.id, data.id)
                              }
                            >
                              Cancel deduction
                            </Button>
                          )}
                          </Box>:""}
                        </InlineStack>
                      </Box>
                    </Box>
                  </InlineStack>
                </Box>
                <Box className="children_content_item_right">
                  <InlineStack blockAlign="center" gap={200}>
                    {item.dsm === 1 ? <Box>
                      <Box>{costQuantityFun(data, item)}</Box>
                      <Box>
                        Total:{" "}
                        <SymbolTake
                          price={parseFloat(item.total).toFixed(2)}
                          shopifyPrice={item.dsm === 1 ? false : true}
                        />
                      </Box>
                    </Box>:''}
                    {item.is_sourcing === 0 || item.is_sourcing === 4 ? (
                      <Box>
                        <Button
                          onClick={() => {
                            handleBatchSourcing([data.id], false);
                          }}
                        >
                          Sourcing
                        </Button>
                      </Box>
                    ) : (
                      <Box style={{ opacity: 0 }}>
                        <Button>Sourcing</Button>
                      </Box>
                    )}
                  </InlineStack>
                </Box>
              </InlineStack>
            </Box>
          </td>
        </IndexTable.Row>
      ));
    }
    return data.show ? node : "";
  };
  const handleGuideOff = async()=>{
    let res = await reqGetNewGuideOrder()
    if (res.code === '200') {
      setNewcomeStep((prev)=>({
        ...prev,
        step3:false
      }))
      isGuideRef.current = false
      setNewcomeGuidance(false)
    }
  }
  const NewGuide = ()=>{
    const style = {position: "absolute",color: "#fff",borderRadius: "5px",zIndex: 1000,whiteSpace: "nowrap",padding:'8px',backgroundColor:'rgba(0, 91, 211, 1)',width:'300px',left:'-40px'}
    let node = (<Box
            className="new_guide_order new_guide_order_1"
            style={style}>
               <InlineStack gap={300}>
                <Box style={{whiteSpace:'wrap'}}>1/3 👇🏻<br />
                Click the order number to view all items in the order.</Box>
                <Box style={{width:'100%'}}>
                <InlineStack gap={300} align="flex-end">
                <Button onClick={(e)=>{
                  e.stopPropagation();
                  setNewcomeStep((prev)=>({
                  ...prev,
                  step1:false,
                  step2:true
                }))}}>Next</Button>
                </InlineStack>
                </Box>
                </InlineStack>
                <img src="/order_fulfillment/polygon.png" alt="logo" />
            </Box>)
            if (newcomeStep.step1) {
              node = (<Box
                className="new_guide_order new_guide_order_1"
                style={style}>
                   <InlineStack gap={300}>
                    <Box  style={{whiteSpace:'wrap'}}>1/3 👇🏻<br />
                    Click the order number to view all items in the order.</Box>
                    <Box style={{width:'100%'}}>
                <InlineStack gap={300} align="flex-end">
                <Button onClick={(e)=>{
                  e.stopPropagation();
                  setNewcomeStep((prev)=>({
                  ...prev,
                  step1:false,
                  step2:true
                }))}}>Next</Button>
                </InlineStack>
                </Box>
                </InlineStack>
                <img src="/order_fulfillment/polygon.png" alt="logo" />
                </Box>)
            }
            if (newcomeStep.step2) {
              node = (<Box
                className="new_guide_order new_guide_order_2"
                style={style}>
                    <InlineStack gap={300}>
                    <Box style={{whiteSpace:'wrap'}}>2/3 👇🏻<br />
                    Click the order status to view both Shopify and Dropshipman statuses.</Box>
                    <Box style={{width:'100%'}}>
                <InlineStack gap={300} align="flex-end">
                <Button onClick={(e)=>{
                  e.stopPropagation();
                  setNewcomeStep((prev)=>({
                  ...prev,
                  step2:false,
                  step3:true
                }))}}>Next</Button>
                </InlineStack>
                </Box>
                </InlineStack>
                <img src="/order_fulfillment/polygon.png" alt="logo" />
                </Box>)
            }
            if (newcomeStep.step3) {
              node = (<Box
                className="new_guide_order new_guide_order_3"
                style={style}>
                    <InlineStack gap={300}>
                    <Box style={{whiteSpace:'wrap'}}>3/3 👇🏻<br />
                    Click the color tag to add a label to the order.</Box>
                    <Box style={{width:'100%'}}>
                <InlineStack gap={300} align="flex-end">
                <Button onClick={(e)=>{
                  e.stopPropagation();
                  handleGuideOff()
                  }}>Ok, I see</Button>
                </InlineStack>
                </Box>
                </InlineStack>
                <img src="/order_fulfillment/polygon.png" alt="logo" />
                </Box>)
            }
       
        return node;
  } 
  const [btnShow, setBtnShow] = useState(""); // 按钮组展示
  const buttonGroup = (data) => {
    let node = "";
    if (data.dsm_paid_at === 0 && data.dsm_record !== 0) {
      node = (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleBulkPayment([data.id]);
          }}
        >
          Payment
        </Button>
      );
    }
    if (data.dsm_paid_at !== 0) {
      node = (
        <InlineStack gap={200}>
          <Button
            variant="plain"
            onClick={(e) => {
              e.stopPropagation();
              setTrackingData((prev) => ({
                ...prev,
                id: data.dsm_record,
                open: true,
                data: {
                  ...data,
                  dsm_order_name:data.dsm_order_name + data.suffix,
                  order_name: data.shopify_order_name,
                },
              }));
            }}
          >
            Tracking
          </Button>
          {data?.is_back !== 1 && data.dsm_payment_status !== "Refund" && (
            <Button
              variant="tertiary"
              onClick={(e) => {
                e.stopPropagation();
                if (binding_sale === 1) {
                  setOrderRefundData((prev) => ({
                    ...prev,
                    id: data.dsm_record,
                    open: true,
                    data: {
                      ...data,
                      dsm_order_number:data.dsm_order_name + data.suffix,
                    },
                  }));
                }else {
                  let sendMsg =
                  `Hi, I would like to request a refund for order ${data.dsm_order_name + data.suffix}`;
                  try {
                    // 填充信息并激活对话弹窗
                    // window.Intercom('showNewMessage', sendMsg)
                    window.Willdesk.show();
                    window.Willdesk.chat(sendMsg);
                  } catch (error) {
                    console.info(error);
                  }
                }
              }}
            >
              Refund
            </Button>
          )}
        </InlineStack>
      );
    }
    if (
      data.dsm_shipment_status === "Fulfilled" ||
      data.dsm_shipment_status === "Delivered"
    ) {
      node = (
        <Popover
          active={btnShow === data.id}
          activator={
            <Button
              variant="tertiary"
              icon={MenuHorizontalIcon}
              onClick={(e) => {
                e.stopPropagation();
                setBtnShow(btnShow === data.id ? "" : data.id);
              }}
            ></Button>
          }
          autofocusTarget="first-node"
          onClose={() => {
            setBtnShow("");
          }}
        >
          <ActionList
            actionRole="menuitem"
            items={[
              {
                content: "Tracking",
                onAction: () => {
                  setTrackingData((prev) => ({
                    ...prev,
                    id: data.dsm_record,
                    open: true,
                    data: {
                      ...data,
                      dsm_order_name:data.dsm_order_name + data.suffix,
                      order_name: data.shopify_order_name,
                    },
                  }));
                },
              },
              data?.is_back !== 1 && {
                content: "Refund",
                onAction: () => {
                  if (binding_sale === 1) {
                    setOrderRefundData((prev) => ({
                      ...prev,
                      id: data.dsm_record,
                      open: true,
                      data: {
                        ...data,
                        dsm_order_number:data.dsm_order_name + data.suffix,
                      },
                    }));
                  }else {
                    let sendMsg =
                    `Hi, I would like to request a refund for order ${data.dsm_order_name + data.suffix}`;
                    try {
                      // 填充信息并激活对话弹窗
                      // window.Intercom('showNewMessage', sendMsg)
                      window.Willdesk.show();
                      window.Willdesk.chat(sendMsg);
                    } catch (error) {
                      console.info(error);
                    }
                  }
                  
                },
              },
              {
                content: "Invoice",
                onAction: (e) => {
                  setInvoicesData((prev) => ({
                    ...prev,
                    id: data.dsm_record,
                    open: true,
                    data: data,
                  }));
                },
              },
            ]}
          />
        </Popover>
      );
    }
    return node;
  };

  // 不包邮订单提示用户选择物流方式
  const noFreeShippingTipsModal = (
    <ShopifyModal
      id="no-free-shipping-tips-modal"
      open={paymentData.noFreeShippingTipsActive}
      heading="Shipping method not selected"
      onClose={() => handleOrderShippingTips(false)}
      secondaryActions={[
        {
          content: "Got it",
          onAction: () => handleOrderShippingTips(false),
        },
      ]}
    >
      <p>
        {"Please choose a shipping method for order "}
        <b>{paymentData.noFreeShippingOrder}</b>
        {"."}
      </p>
    </ShopifyModal>
  );
  // 总价转换
  const [isShow, setIsShow] = useState("");
  const TotalFun = ({ data }) => {
    let total =
      parseFloat(data.product_cost) +
      parseFloat(data.shipping_cost) +
      parseFloat(data.ioss_vat) -
      parseFloat(data.coupon_money);
    total = Math.max(total, 0).toFixed(2);
    let node = (
      <Box>
        <Popover
          active={isShow === data.id}
          activator={
            <span
              className="order_total_text"
              onMouseEnter={() => {
                setIsShow(data.id);
              }}
            >
              ${total}
            </span>
          }
          autofocusTarget="first-node"
          onClose={() => {
            setIsShow("");
          }}
        >
          <Box style={{ width: "200px", padding: "10px" }}>
            <Box>
            Product Cost:{" "}
              <SymbolTake price={parseFloat(data.product_cost).toFixed(2)} />
            </Box>
            <Box>
              Discounted:{" "}
              {data.coupon_money > 0 ? (
                <SymbolTake price={parseFloat(data.coupon_money).toFixed(2)} />
              ) : (
                "$0.00"
              )}
            </Box>
            <Box>
              Shipping Cost:{" "}
              <SymbolTake price={parseFloat(data.shipping_cost).toFixed(2)} />
            </Box>
            <Box>
              VAT: <SymbolTake price={parseFloat(data.ioss_vat).toFixed(2)} />
            </Box>
            <Box>
              Total: <SymbolTake price={total} />
            </Box>
          </Box>
        </Popover>
      </Box>
    );

    return node;
  };
  // 进度器
  // 1. 默认展示4个进度器，当存在未source完成时有5个进度器;
  // 2. 每个进度器有多种状态，但仅展示当前进度的状态
  // 3. 4个进度器中，默认仅展示一个核心状态，其他进度器为灰色且无内容，只有鼠标移上指定的进度器才展示内容
  // 4. 鼠标移上进度器会有动画过渡效果，比如从左往右移动动效就是从左往右。

  const ProgressGroup = ({ data }) => {
    const [currentIndexProgress, setCurrentIndexProgress] = useState(
      data.currentShow
    );
    // 默认状态内容
    let shopifyPaid = [
      {
        bg: "rgba(205, 254, 225, 1)",
        color: "rgba(12, 81, 50, 1)",
        content: "Paid",
        id: "paid",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(255, 239, 157, 1)",
        color: "rgba(79, 71, 0, 1)",
        content: "Unpaid",
        id: "unpaid",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Pending",
        id: "pending",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Authorized",
        id: "authorized",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Partially paid",
        id: "partially_paid",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(255, 214, 164, 1)",
        color: "rgba(94, 66, 0, 1)",
        content: "Partially refunded",
        id: "partially_refunded",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(254, 218, 217, 1)",
        color: "rgba(142, 31, 11, 1)",
        content: "Refunded",
        id: "refunded",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Voided",
        id: "voided",
        tips: "Shopify payment status",
        icon: "/shop-icon-shopify.png",
      },
    ];
    let sourcingStats = [
      {
        bg: "rgba(255, 239, 157, 1)",
        color: "rgba(79, 71, 0, 1)",
        content: "Awaiting Sourcing",
        id: "Awaiting sourcing",
        tips: "Sourcing status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Pending Sourcing",
        id: "Pending sourcing",
        tips: "Sourcing status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(254, 218, 217, 1)",
        color: "rgba(142, 31, 11, 1)",
        content: "Unsourcing",
        id: "Not sourcing",
        tips: "Sourcing status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(254, 218, 217, 1)",
        color: "rgba(142, 31, 11, 1)",
        content: "Sourcing Failed",
        id: "Sourcing failed",
        tips: "Sourcing status",
        icon: "/dropshipman-logo.png",
      },
    ];

    let dsmPaid = [
      {
        bg: "rgba(205, 254, 225, 1)",
        color: "rgba(12, 81, 50, 1)",
        content: "Paid",
        id: "Paid",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(255, 239, 157, 1)",
        color: "rgba(79, 71, 0, 1)",
        content: "Unpaid",
        id: "Unpaid",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(224, 240, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Pending",
        id: "Pending",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(254, 218, 217, 1)",
        color: "rgba(142, 31, 11, 1)",
        content: "Refunded",
        id: "Refund",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(255, 214, 164, 1)",
        color: "rgba(94, 66, 0, 1)",
        content: "Partially Refunded",
        id: "Partially refund",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Partially Paid",
        id: "Partially paid",
        tips: "Dropshipman payment status",
        icon: "/dropshipman-logo.png",
      },
    ];

    let dsmFulfilled = [
      {
        bg: "rgba(205, 254, 225, 1)",
        color: "rgba(12, 81, 50, 1)",
        content: "Fulfilled",
        id: "Fulfilled",
        tips: "Dropshipman fulfillment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(243, 243, 243, 1)",
        color: "rgba(97, 97, 97, 1)",
        content: "Unfulfilled",
        id: "Unfulfilled",
        tips: "Dropshipman fulfillment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "In Processing",
        id: "In processing",
        tips: "Dropshipman fulfillment status",
        icon: "/dropshipman-logo.png",
      },
      {
        bg: "rgba(205, 254, 225, 1)",
        color: "rgba(12, 81, 50, 1)",
        content: "Delivered",
        id: "Delivered",
        tips: "Dropshipman fulfillment status",
        icon: "/dropshipman-logo.png",
      },
    ];
    let shopifyFulfilled = [
      {
        bg: "rgba(205, 254, 225, 1)",
        color: "rgba(12, 81, 50, 1)",
        content: "Fulfilled",
        id: "fulfilled",
        tips: "Shopify fulfillment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(243, 243, 243, 1)",
        color: "rgba(97, 97, 97, 1)",
        content: "Unfulfilled",
        id: "unfulfilled",
        tips: "Shopify fulfillment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(202, 230, 255, 1)",
        color: "rgba(0, 82, 124, 1)",
        content: "Partially fulfilled",
        id: "partial",
        tips: "Shopify fulfillment status",
        icon: "/shop-icon-shopify.png",
      },
      {
        bg: "rgba(255, 214, 164, 1)",
        color: "rgba(94, 66, 0, 1)",
        content: "Restocked",
        id: "restocked",
        tips: "Shopify fulfillment status",
        icon: "/shop-icon-shopify.png",
      },
    ];

    // 根据 data 动态生成进度状态
    let currentProgress = [];
    if (data.shopify_financial_status) {
      const shopifyStatus = shopifyPaid.find(
        (status) => status.id === data.shopify_financial_status
      );
      if (shopifyStatus) {
        currentProgress.push(shopifyStatus);
      } else if (
        data?.shopify_financial_status &&
        data?.shopify_financial_status !== ""
      ) {
        currentProgress.push({
          bg: "rgb(243, 243, 243)",
          color: "rgb(97, 97, 97)",
          content: data.shopify_financial_status,
          id: "",
          tips: "Dropshipman payment status",
          icon: "/shop-icon-shopify.png",
        });
      }
    }

    // 增加其他状态的处理逻辑
    if (data.sourcing_status) {
      const sourcingStatus = sourcingStats.find(
        (status) => status.id === data.sourcing_status
      );
      if (sourcingStatus) {
        currentProgress.push(sourcingStatus);
      }
    }

    if (data.dsm_payment_status) {
      const dsmPaidStatus = dsmPaid.find(
        (status) => status.id === data.dsm_payment_status
      );
      if (dsmPaidStatus) {
        currentProgress.push(dsmPaidStatus);
      } else if (data.dsm_payment_status !== "") {
        currentProgress.push({
          bg: "rgb(243, 243, 243)",
          color: "rgb(97, 97, 97)",
          content: data.dsm_payment_status,
          tips: "Dropshipman payment status",
          icon: "/dropshipman-logo.png",
        });
      }
    }

    if (data.dsm_shipment_status) {
      const dsmFulfilledStatus = dsmFulfilled.find(
        (status) => status.id === data.dsm_shipment_status
      );
      if (dsmFulfilledStatus) {
        currentProgress.push(dsmFulfilledStatus);
      }
    }
    if (data.shopify_fulfillment_status) {
      const fulfillmentStatus = shopifyFulfilled.find(
        (status) => status.id === data.shopify_fulfillment_status
      );
      if (fulfillmentStatus) {
        currentProgress.push(fulfillmentStatus);
      }
    }
    let currentIndex = currentIndexProgress
      ? currentIndexProgress
      : data?.currentShow;

    // 渲染进度器
    return (
      <div
        className="progress-group"
        onMouseLeave={() => {
          setCurrentIndexProgress(data.currentShow);
        }}
      >
        {currentProgress.map((item, index) => (
          <div
            key={index}
            className={
              currentIndex === index + 1
                ? "progress-item"
                : "progress-item progress-item-hide"
            }
            style={{
              backgroundColor: currentIndex === index + 1 ? item?.bg : "#ddd",
              color: currentIndex === index + 1 ? item.color : "transparent",
              width:
                currentIndex === index + 1
                  ? `${item?.content?.length * 10}px`
                  : "0",
              transition: "all 0.3s ease",
              overflow: "hidden",
              whiteSpace: "nowrap",
              fontWeight: 550,
            }}
            onMouseEnter={() => {
              // 鼠标移上时，更新当前显示的进度
              setCurrentIndexProgress(index + 1);
            }}
          >
            <Tooltip
              width="200"
              content={
                <Box>
                  <InlineStack gap={100} blockAlign="center">
                    {item?.icon && (
                      <Thumbnail
                        source={item?.icon}
                        size="extraSmall"
                        alt={item?.tips}
                      />
                    )}
                    <Box>{item?.tips}</Box>
                  </InlineStack>
                </Box>
              }
            >
              <span className="progress_content_span">{item?.content}</span>
            </Tooltip>
          </div>
        ))}
      </div>
    );
  };

  const rowMarkup = listData?.list?.map((item, ind) => {
    // 1. 制作一个手风琴向下展开的盒子
    // 2. 通过控制是否展开的状态，控制是否显示下面的内容
    // 3. 向下展开时有动画效果，收起时也有动画效果

    return (
      <Fragment key={ind}>
        <IndexTable.Row
          id={item.id}
          key={ind}
          selected={selectedResources.includes(item.id)}
          position={ind}
          onClick={() => {
            if (btnShow !== "") {
              return;
            }
            handleClick(item, ind);
          }}
        >
          <IndexTable.Cell className={`order_cell_01 ${newcomeGuidance ? "order_cell_guide" : ""}`}>
            <Box
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
                handleCloseFailedTip()
              }}
              style={{position: "relative"}}
            >
              <Box>
                <InlineStack gap={100} blockAlign="center">
                  <Box>
                    <ColorTag id={item.id} dot={item.dot_sign} shopifyRecord={item.shopify_record} />
                  </Box>
                  <Box className="order_cell_01_title" onClick={(e)=>{
                    e.stopPropagation();
                  }}>
                    <a href={item?.shopify_order_uri} target="_blank" rel="noopener noreferrer">
                    {item.shopify_order_name}
                    </a>
                  </Box>
                  {item.split_order !== 0 ? (
                    <Box>
                      <Badge>Split Order{item.split_order}</Badge>
                    </Box>
                  ) : (
                    ""
                  )}
                </InlineStack>
              </Box>
              {item.dsm_order_name && (
                <Box className="order_cell_01_dsm">
                  DSM order {item.dsm_order_name}
                  {item.suffix}
                </Box>
              )}
            {(ind === 0 && !newcomeStep.step2 && newcomeGuidance )? <NewGuide />:''}
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_02">
            <Box
              className="progress_group_box"
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
                handleCloseFailedTip()
              }}
              style={{position: "relative"}}
            >
              <ProgressGroup
                data={{
                  ...item,
                  currentShow:
                    item.sourcing_status !== "" ? 2 : item?.order_process,
                }}
              />
              {(ind === 0 && newcomeStep.step2 && newcomeGuidance ) ? <NewGuide />:''}
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_03">
            <Box>
              <Box className="dsm_order_date_text">{item.shopify_date}</Box>
              <Box>{item.dsm_date}</Box>
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_04">
            <Box
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
                handleCloseFailedTip()
              }}
            >
              <InlineStack gap={100} blockAlign="center">
                <div className="order_customer_info">
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      setAddressData({ ...item, open: true });
                    }}
                    variant="palin"
                    size="micro"
                    loading={false}
                  >
                    <Tooltip
                      content={
                        "Click to edit customer shipping address and information"
                      }
                    >
                      <InlineStack gap={100} blockAlign="center" wrap={false}>
                        <span>
                          <Icon source={PersonIcon} tone="base" />
                        </span>
                        {item.address_failed ? (
                          <div>
                            <img
                              src="/order_fulfillment/failed_icon.png"
                              alt="dropshipman"
                            />
                          </div>
                        ) : (
                          <span className="order_icon_dwon">
                            <Icon source={ChevronDownIcon} />
                          </span>
                        )}
                      </InlineStack>
                    </Tooltip>
                  </Button>
                </div>
              </InlineStack>
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_05">
            {item.dsm_record !== 0 ? (
              <Box
                onMouseLeave={() => {
                  setIsShow("");
                  setCurrentShowDot("");
                  handleCloseFailedTip()
                }}
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    setisShowPackingOrderModal({
                      open: true,
                      data: item,
                    });
                  }}
                  variant="palin"
                  size="micro"
                  loading={false}
                >
                  <InlineStack  wrap={false}>
                    <img src="/order_fulfillment/package_icon.png" alt="logo" />
                    <span className="order_icon_dwon">
                      <Icon source={ChevronDownIcon} />
                    </span>
                  </InlineStack>
                </Button>
              </Box>
            ) : (
              "-"
            )}
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_06">
            {item.dsm_record !== 0 ? (
              <Box
                onMouseLeave={() => {
                  setIsShow("");
                  setCurrentShowDot("");
                  handleCloseFailedTip()
                }}
              >
                <Box>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();

                      setShippingMethodsData({ ...item, open: true });
                    }}
                    variant="palin"
                    size="micro"
                    loading={false}
                  >
                    <InlineStack>
                      <span className="order_cost_text">
                        Cost:{" "}
                        <SymbolTake
                          price={parseFloat(item.shipping_cost).toFixed(2)}
                        />
                      </span>
                      <span className="order_icon_dwon">
                        <Icon source={ChevronDownIcon} />
                      </span>
                    </InlineStack>
                  </Button>
                </Box>
                <Box>{item.dsm_shipping}</Box>
              </Box>
            ) : (
              "-"
            )}
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_07">
            <Box
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
                handleCloseFailedTip()
              }}
            >
              <Box>{item.shopify_item_count} Total</Box>
              {item.dsm_record !== 0 && item.dsm_paid_at === 0 && (
                <Box>{item.dsm_item_count} Payable</Box>
              )}
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell
            className="order_cell_08"
            onMouseLeave={() => {
              setIsShow("");
              setCurrentShowDot("");
              handleCloseFailedTip()
            }}
          >
            <Box
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
                handleCloseFailedTip()
              }}
            >
              {item.dsm_record === 0 ? "-" : <TotalFun data={item} />}
              {item.dsm_paid_at !== 0 && item.coupon_money !== 0 ? (
                <Box className="pay_line">
                  <SymbolTake
                    price={(
                      parseFloat(item.product_cost) +
                      parseFloat(item.shipping_cost) +
                      parseFloat(item.ioss_vat)
                    ).toFixed(2)}
                  />
                </Box>
              ) : (
                ""
              )}
            </Box>
          </IndexTable.Cell>
          <IndexTable.Cell className="order_cell_09">
            <Box
              onMouseLeave={() => {
                setIsShow("");
                setCurrentShowDot("");
              }}
            >
              <InlineStack>{buttonGroup(item)}</InlineStack>
            </Box>
          </IndexTable.Cell>
        </IndexTable.Row>
        <ChildrenItem data={item} skuPop={listData?.sku_pop} />
      </Fragment>
    );
  });
  // 订单地址异常支付提醒
  let addressFailedTips = (
    <ShopifyModal
      id="address-failed-tips-modal"
      open={paymentData.addressFailedModal}
      onClose={() => handleAddressFailedTips(false)}
      heading="Incorrect customer information"
      primaryAction={{
        content: "Cancel",
        onAction: () => handleAddressFailedTips(false),
      }}
      secondaryActions={[
        {
          content: "Continue to pay",
          onAction: () => handleAddressFailedOrderToUnpaid(),
          loading: paymentData.addressFailedLoading,
        },
      ]}
    >
      <p>
        {"The customer information for order"}{" "}
        <span style={{ fontWeight: "500" }}>
          {paymentData.addressFailedOrder}
        </span>{" "}
        {
          "is incorrect. This may affect the normal delivery of the order and we suggest correcting the information before paying."
        }
      </p>
    </ShopifyModal>
  );
  // shopify已退款订单批量支付提醒
  let shopifyRefundOrder = (
    <ShopifyModal
      id="shopify-refund-order-modal"
      open={shopifyOrderRefundModalData.shopifyOrderRefundModal}
      onClose={() =>
        setShopifyOrderRefundModalData((prevValue) => ({
          ...prevValue,
          shopifyOrderRefundModal: false,
        }))
      }
      heading="Payment confirmation"
      primaryAction={{
        content: "Continue to pay",
        onAction: () => {
          setShopifyOrderRefundModalData((prevValue) => ({
            ...prevValue,
            shopifyOrderRefundModal: false,
          }));
          setPaymentData((prevValue) => ({
            ...prevValue,
            isShowBulkPaymentModal: true,
          }));
        },
      }}
      secondaryActions={{
        content: "Cancel",
        onAction: () =>
          setShopifyOrderRefundModalData((prevValue) => ({
            ...prevValue,
            shopifyOrderRefundModal: false,
          })),
      }}
    >
      {shopifyOrderRefundModalData.shopifyRefundOrderData
        .shopifyRefundStatus === "refunded" ? (
        <p>
          {
            "This order has been refunded by the customer at Shopify, please confirm whether you want to continue to pay."
          }
        </p>
      ) : (
        <p>
          {
            "Some items of this order have been refunded by the customer at Shopify, please confirm whether you want to continue to pay."
          }
        </p>
      )}
    </ShopifyModal>
  );
  // 支付进度显示
  let paymentTips = <div></div>;
  if (paymentData.operationNumber !== 0) {
    paymentTips = (
      <div style={{ marginBottom: "1rem" }}>
        <Banner
          title={
            paymentData.currentExecutionsNumber +
            "/" +
            paymentData.operationNumber +
            " orders are being paid."
          }
          tone="info"
          // onDismiss={() => {}}
        ></Banner>
      </div>
    );
  }
  // 定义参数有效性检查工具函数
  const hasValidParams = (params) => {
    if (!params) return false;

    // 需要验证的非空字符串参数
    const stringParams = ["query_value", "start_time", "end_time"];

    // 需要验证的非空数组参数
    const arrayParams = ["payment_status"];

    // 检查字符串参数
    const hasValidString = stringParams.some(
      (key) => params[key] !== undefined && params[key] !== ""
    );

    // 检查数组参数
    const hasValidArray = arrayParams.some((key) => params[key]?.length > 0);

    return hasValidString || hasValidArray;
  };
  const emptyStateMarkup =
    Object.values(listData).length > 0 ? (
      <Box>
        {listData?.list?.length === 0 && (
          <Box>
            {hasValidParams(requestParams) ? (
              <InitNotPageContent data={{ q: requestParams.query_value }} />
            ) : (
              <InitPageContent selected={selected} setNoviceModal={() => {}} />
            )}
          </Box>
        )}
      </Box>
    ) : (
      <CommonTableSkeletonItem />
    );
  const itemCountFun = () => {
    let num = 0;
    if (selectableOrders?.length) {
      num = selectableOrders.length;
      if (listData?.list?.length) {
        num = listData?.list?.length;
      }
    }
    if (num > requestParams.size) {
      num = requestParams.size;
    }
    return num;
  };
  const selectedItemsCountFun = () => {
    let num = 0;
    if (allResourcesSelected) {
      num = "All";
    } else {
      num =
        selectedResources.length > requestParams.size
          ? requestParams.size
          : selectedResources.length;
    }

    return num;
  };
  const widthPage = useScreenWidth();
  return (
    <div
      className={newcomeGuidance ? "order_table_box product_table_box order_table_box_min" : "order_table_box product_table_box"}
      onMouseLeave={() => {
        setIsShow("");
        setCurrentShowDot("");
        handleCloseFailedTip()
      }}
    >
      {paymentTips}
      <IndexTable
        resourceName={resourceName}
        itemCount={itemCountFun()}
        selectedItemsCount={selectedItemsCountFun()}
        selectable={selected !== 3}
        onSelectionChange={handleSelectionChange}
        headings={headingData}
        promotedBulkActions={widthPage <= 600 ? [] : promotedBulkActions}
        bulkActions={widthPage <= 600 ? promotedBulkActions : []}
        emptyState={emptyStateMarkup}
        pagination={{
          label: listData?.list?.length > 0 ? pageMsg() : "",
          hasPrevious: hasPrevious,
          onPrevious: () => {
            handlePrev();
          },
          hasNext: hasNext,
          onNext: () => {
            handleNext();
          },
        }}
      >
        {rowMarkup}
      </IndexTable>
      {/* 礼品包装数据 */}
      <OrderPackageModal
        open={isShowPackingOrderModal.open}
        setisShowPackingOrderModal={setisShowPackingOrderModal}
        item={isShowPackingOrderModal.data}
      />

      {/* 复选框阻断提示 */}
      <PaymentCheckModal
        setIsItemCheck={setIsItemCheck}
        isItemCheck={isItemCheck}
        listData={listData}
        setListData={setListData}
        toastFun={toastFun}
        setSearchLoading={setSearchLoading}
        getPageData={getPageData}
      />

      {/* 归档/解档 */}
      <ArchiveOrderModal
        archiveOrderData={archiveOrderData}
        getPageData={getPageData}
        toastFun={toastFun}
        setArchiveOrderData={setArchiveOrderData}
      />
      <OrderInventoryModal
        cancelInventory={cancelInventory}
        setCancelInventory={setCancelInventory}
        getPageData={getPageData} //获取页面数据
      />

      {/* 批量source */}
      <BulkSourcingModal
        bulkSourceData={bulkSourceData}
        setBulkSourceData={setBulkSourceData}
        getPageData={getPageData}
        toastFun={toastFun}
      />
      {/* sourcing提示 */}
      <SourcingOrderTipModal
        bulkSourceData={bulkSourceData}
        setBulkSourceData={setBulkSourceData}
      />

      {/* 物流轨迹 */}
      {/* 礼品包装数据 */}
      {/* 地址选择 */}
      {addressData.open && (
        <CustomerInformationModal
          setAddressData={setAddressData}
          open={addressData.open}
          id={addressData.dsm_record}
          sid={addressData.shopify_record}
          type={1}
          toastFun={toastFun}
          countryCode={addressData.shipping_country}
          paymentStatus={addressData.dsm_payment_status}
          addressStatus={addressData.address_failed}
          requestParams={requestParams}
          getPageData={getPageData}
          setSearchLoading={setSearchLoading}
        />
      )}
      {/* 物流方式选择 */}
      <ShippingMethodsModal
        orderId={shippingMethodsData.dsm_record}
        requestParams={requestParams}
        getPageData={getPageData}
        open={shippingMethodsData.open}
        orderPayStatus={shippingMethodsData.dsm_payment_status}
        setIsShowShippingMethodsModal={() =>
          setShippingMethodsData({ open: false })
        }
      />

      {/* 物流轨迹 */}
      {trackingData.open && (
        <OrderTrackingModal
          trackingData={trackingData}
          toastFun={toastFun}
          setTrackingData={setTrackingData}
          handleStoreTabChange={handleStoreTabChange}
        />
      )}
      {/* 退款详情弹窗 销售绑定信息 */}
      <RefundTipsModal
        open={orderRefundData.open}
        datas={orderRefundData.data}
        setIsShowRefundTipsModal={() =>
          setOrderRefundData((prev) => ({
            ...prev,
            open: false,
          }))
        }
      />
      {/* 开票弹窗 */}
      <OrderInvoiceModal
        toastFun={toastFun}
        data={invoicesData}
        callColse={() => {
          setInvoicesData((prev) => ({
            ...prev,
            open: false,
          }));
        }}
      />

      {/* 支付模块 */}
      {/* 批量支付弹窗 */}
      <BulkPaymentModal
        handlePayForOrderModal={handlePayForOrderModal}
        paymentData={paymentData}
        setDlocalTip={setDlocalTip}
        payoneerAuth={listData.payoneer_auth} //payoneer授权
        setPayoneerConnectOpen={setPayoneerConnectOpen}
        setPayoneerBalances={setPayoneerBalances}
        setIsShowBulkPaymentModal={() => {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isShowBulkPaymentModal: false,
          }));
        }}
        walletMoney={listData.wallet_money}
      />
      <PayForOrderModal
        paymentData={paymentData}
        handlePayForOrderModal={handlePayForOrderModal}
        getPageData={getPageData} //获取页面数据
        orderPayment={true}
      />
      {/* 钱包支付 */}
      <WalletForOrderModal
        paymentData={paymentData}
        handleWalletActive={handleWalletActive}
        walletMoney={listData?.wallet_money}
        handlePayForOrderModal={handlePayForOrderModal}
      />
      {/* 订单支付 未sourcing完成sku订单提示 */}
      <NotSourcingCompleteModal
        open={paymentData.isNotSourcing}
        paymentData={paymentData}
        setPaymentData={setPaymentData}
      />
      {/* 物流提示 */}
      {noFreeShippingTipsModal}
      {/* 订单地址异常支付提醒 */}
      {addressFailedTips}

      {/* payoneer未授权 */}
      <PayoneerBalancesConnect
        open={payoneerConnectOpen}
        callPayoneerConnectClosed={callPayoneerConnectClosed}
      />
      {/* 选择payoneer支付账户 */}
      <PayoneerBalancesOrderSelect
        datas={payoneerBalances}
        setPayoneerBalances={setPayoneerBalances}
        handlePayoneerConfirm={handlePayoneerConfirm}
      />
      {/* 确认付款 */}
      <PayoneerBalancesOrderConfirm
        handlePayoneerConfirmClose={handlePayoneerConfirmClose}
        data={payoneerConfirm.data}
        open={payoneerConfirm.open}
        setPayoneerAgainOpen={setPayoneerAgainOpen}
        setPayoneerConfirm={setPayoneerConfirm}
      />
      <PayoneerBalancesAgain
        open={payoneerAgainOpen}
        callPayoneerAgainClosed={callPayoneerAgainClosed}
      />
      {shopifyRefundOrder}
      {/* dlocal支付完成提示 */}
      <DlocalPayTipModal
        setDlocalTip={setDlocalTip}
        dlocalTip={dlocalTip}
        getPageData={getPageData}
      />
    </div>
  );
};
// 获取屏幕宽度
const useScreenWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return width;
};
export default OrderTable;
